import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class HolidaysModule {
    constructor() {
        this.holidays = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(holiday) {
        this.holidays = holiday;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.holidays;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.holidays.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(holiday) {
        try {
            await service.holidays.add(holiday);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(holiday) {
        try {
            await service.holidays.edit(holiday);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(holiday) {
        try {
            await service.holidays.delete(holiday);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], HolidaysModule.prototype, "holidays", void 0);
__decorate([
    State()
], HolidaysModule.prototype, "count", void 0);
__decorate([
    State()
], HolidaysModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], HolidaysModule.prototype, "setItems", null);
__decorate([
    Mutation()
], HolidaysModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], HolidaysModule.prototype, "setError", null);
__decorate([
    Getter()
], HolidaysModule.prototype, "list", null);
__decorate([
    Getter()
], HolidaysModule.prototype, "total", null);
__decorate([
    Getter()
], HolidaysModule.prototype, "errorList", null);
__decorate([
    Action()
], HolidaysModule.prototype, "get", null);
__decorate([
    Action()
], HolidaysModule.prototype, "add", null);
__decorate([
    Action()
], HolidaysModule.prototype, "edit", null);
__decorate([
    Action()
], HolidaysModule.prototype, "delete", null);
